import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { selectSignUpNodisturb, selectSignUpSubscriptions } from 'state/selectors/signUpSelectors';
import {
  selectSelectedGroupIds,
  selectOptInGroups,
  selectShouldShowIncidentSub } from 'state/selectors/subscriptionSelectors';
import SkipButton from 'commons/SkipButton';
import SaveButton from 'commons/SaveButton';
import CancelButton from 'commons/CancelButton';
import * as signUpConstants from 'constants/signUp';
import * as signUpActions from 'state/actions/signUpActions';
import * as subscriptionActions from 'state/actions/subscriptionActions';
import { goNextPage, isEditPage } from 'utils/ebUtils';
import ReactGA from 'react-ga';
import { orgId, setPageTitle } from 'utils';
import { I18N, I18NConsumer, GlobalContext, EBModal } from 'commons';
import { navigate } from '@reach/router';
import SignUpHeader from '../SignUpHeader';
import SignUpContent from '../SignUpContent';
import SubscriptionContent from './SubscriptionContent';
import GroupSubscriptionContent from './GroupSubscriptionContent';
import './Subscriptions.scss';
import SubscriptionCard from '../InformationCard';
import IncidentSubscriptions from './IncidentSubscriptions';
import AlertBox from 'components/forms/AlertBox'
import { ajaxLoadingSubscriptions } from '../../../utils/Ajax';


const Subscriptions = ({
  optInGroups,
  subscriptions,
  updateAlertSubscriptionList,
  selectedGroupIds,
  updateGroupSubscriptionData,
  getSubscriptions,
  getGroupSubscriptionData,
  nodisturb,
  clearData,
  isEditMode,
  shouldIncidentSubShow,
  checkShowIncidentSub
}) => {
  const {
    organization: {
      orgName, showAlertSubscription, showGroupSubscription, showIncidentSub,
      showAlertSubscriptionTimeZone, showCustomfield,
    },
    account: { id: contactId, CSRF_TOKEN_FOR_SESSION: csrfToken = '', name: accountName = '' },
    lang,
  } = useContext(GlobalContext);
  const tipLocationText = 'ssp.subscription.profile.tip';
  const tipLocationTitle = 'ssp.main.title.subscriptions';
  const isNewEditPage = isEditPage('edit-subscriptions');
  const [alertData, setAlertData] = useState({});
  const [groupData, setGroupData] = useState({});
  const [isOpenUncheckConfirm, setIsOpenUncheckConfirm] = useState(false);
  const [isShowSkipBtn, setIsShowSkipBtn] = useState(true);
  const [isShowAlertInfo, setIsShowAlertInfo] = useState(false);
  const [incSubUpdateStatus, setIncSubUpdateStatus] = useState();
  const [loadingIncSubs, setLoadingIncSubs] = useState(true);
  const [alertContent, setAlertContent] = useState('');
  const [isGroupAndAlertSave, setIsGroupAndAlertSave] = useState(false);
  const [nodisturbData, setNodisturbData] = useState({
    startTime: '',
    endTime: '',
    timeZoneId: '',
    startMeridiem: '',
    endMeridiem: '',
    wheatherChecked: false
  });
  const [saveIncSubAssignments, setSaveIncSubAssignments] = useState(() => {});
  const [isSavedSucceed, setSavedSucceed] = useState(false)
  const displaySaveButton = !shouldIncidentSubShow || (!loadingIncSubs && shouldIncidentSubShow);
  const handleSave = () => {
    ajaxLoadingSubscriptions.show();
    const { startTime, endTime, timeZoneId, startMeridiem, endMeridiem, wheatherChecked } = nodisturbData;
    const promiseList = [];

    if (showAlertSubscription) {
      // validate
      if (showAlertSubscriptionTimeZone) {
        if (wheatherChecked) {
          if (!timeZoneId) {
            setAlertContent('ssp.controller.subscription.set.timezone');
            setIsShowAlertInfo(true);
            return;
          }
          if ((startMeridiem === endMeridiem)
            && (startTime === endTime)) {
            setAlertContent('alertSubscription.dialog.content.equal');
            setIsShowAlertInfo(true);
            return;
          }
        }
      }

      let firstEl = 0
      for (let index = 0; index < subHeap.length; index++) {
        if (subHeapDict[index]) {
          continue
        } else {
          firstEl = index
          break
        }
      }
      let subs = subHeap.slice(firstEl)
      if (subs.length === 0) {
        return;
      }

      let nodisturb = {};
      if (showAlertSubscriptionTimeZone) {
        nodisturb = {
          startTime,
          endTime,
          timeZoneId,
          startMeridiem,
          endMeridiem,
          checked: wheatherChecked
        };
      }

      const alertSubPromise = new Promise((resolve, reject) => {
        updateAlertSubscriptionList(
          contactId,
          {
            subs,
            nodisturb,
            successCallback: resolve,
            failCallback: reject,
          });
      });
      promiseList.push(alertSubPromise);
    }

    if (showGroupSubscription) {
      const removeGroups = [];
      const addGroups = [];
      Object.keys(groupData).forEach((key) => {
        if (_.includes(selectedGroupIds, Number(key)) && !groupData[key]) {
          removeGroups.push(Number(key));
        } else if (groupData[key]) {
          addGroups.push(Number(key));
        }
      });


      const groupSubPromise = new Promise((resolve, reject) => {
        updateGroupSubscriptionData(
          contactId,
          {
            removeGroups,
            addGroups,
            successCallback: resolve,
            failCallback: reject,
          });
      });
      promiseList.push(groupSubPromise);
    }

    // save IncidentSubscription
    if (shouldIncidentSubShow) {
      try {
        saveIncSubAssignments(() => {
          setIncSubUpdateStatus(true);
        });
      } catch (e) { }
    }

    Promise.all(promiseList).then(() => {
      setSavedSucceed(true)
      if (!shouldIncidentSubShow) {
        if (isEditMode) {
        } else {
          const param = { 
            pageUri: 'edit-subscriptions', 
            showCustomfield, 
            contactId,
          };
          goNextPage(param);
        }
      } else {
        setIsGroupAndAlertSave(true);
      }
    }).catch(error => {
      setIsGroupAndAlertSave(false);
      setSavedSucceed(false)
    }).finally(() => {
      ajaxLoadingSubscriptions.hide();
    });
  };

  const [subHeap, setSubHeap] = useState([])
  const [subHeapDict, setSubHeapDict] = useState([])
  const updateSubHeap = (indexes, checked) => {
    // emit every time checkbox got clicked, update state by heap
    let i = 1
    let isLeaf = false
    let supLog = []

    const tempIndexes = indexes
    while (tempIndexes.length) {
      let offset = tempIndexes.pop()
      supLog.push(i + offset)
      if (subHeapDict[i + offset] == null) {
        isLeaf = true
        let temp = [...subHeap]
        temp[i + offset].checked = checked
        setSubHeap(temp)
      } else {
        i = subHeapDict[i + offset].childIndex
      }
    }
    if (!isLeaf) {
      let temp = [...subHeap]
      checkNotLeafNode(supLog[supLog.length-1], checked, temp)
      setSubHeap(temp)
    }

    let temp = [...subHeap]
    if (!checked) {
      for (let i of supLog) {
        temp[i].checked = checked
      }
    } else {
      while (supLog.length) {
        let idx = supLog.pop()
        if (subHeapDict[idx] == null) {
          continue
        } else {
          let start = subHeapDict[idx].childIndex
          let end = subHeapDict[idx].childIndex + subHeapDict[idx].count
          let allChecked = true
          for (let i = start; i < end; i++) {
            if (!subHeap[i].checked) {
              allChecked = false
            }
          }
          if (allChecked) {
            temp[idx].checked = checked
          } else {
            break
          }
        }
      }
      setSubHeap(temp)
    }
  }

  const checkNotLeafNode = (index, checked, temp) => {
    temp[index].checked = checked
    let checkedItem = subHeapDict[index]
    let start = checkedItem.childIndex
    let end = checkedItem.childIndex + checkedItem.count
    for (let i = start; i < end; i++) {
      if (subHeapDict[i] != null) {
        checkNotLeafNode(i, checked, temp)
      } else {
        temp[i].checked = checked
      }
    }
    return
  }

  const makeHeapBySubs = () => {
    // make a tree out of subscription
    const heap = ['']
    const heapDict = [{childIndex: 1, level: 0, count: subscriptions.length}]
    const queue = []
    for (let i of subscriptions) {
      queue.push(i)
    }
    let n = 1
    while (queue.length) {
      let node = queue.shift()
      
      heap.push({
        serviceId: node.serviceId,
        checked: node.checked,
        name: node.name,
        type: node.type,
        weatherCategoryList: node.weatherCategoryList
      })
      
      if (node.nodes) {
        heapDict.push({
          childIndex: heapDict[heap.length - 2].childIndex + heapDict[heap.length - 2].count,
          level: node.level == 'one' ? 1: node.level,
          count: node.nodes.length
        })
        for (let child of node.nodes) {
          let temp = {...child, level: heapDict[heap.length - 2].level + 2}
          queue.push(temp)
        }
      } else {
        heapDict.push(null)
      }
    }
    setSubHeap(heap)
    setSubHeapDict(heapDict)
  }

  useEffect(() => {
    makeHeapBySubs()
  }, [subscriptions])

  useEffect(() => {
    if (typeof incSubUpdateStatus !== 'boolean') {
      return;
    }

    if (shouldIncidentSubShow) {
      if (incSubUpdateStatus && isGroupAndAlertSave) {
        if (isEditMode) {
          setSavedSucceed(true)
        } else {
          const param = { 
            pageUri: 'edit-subscriptions', 
            showCustomfield, 
            contactId
          };
          goNextPage(param);
        }
      }
    }
  }, [isGroupAndAlertSave, incSubUpdateStatus]);

  useEffect(() => {
    ReactGA.pageview(`/newRegistration/subscriptionPage/${orgId}`);

    if (showAlertSubscription) {
      getSubscriptions(contactId);
    }
    if (showGroupSubscription) {
      getGroupSubscriptionData(contactId);
    }
    checkShowIncidentSub({
      contactId,
      csrfToken,
      showAlertSubscription,
      showGroupSubscription,
      showIncidentSub });

    return clearData;
  }, []);

  useEffect(() => {
    setNodisturbData({
      startTime: nodisturb.startTime,
      endTime: nodisturb.endTime,
      timeZoneId: nodisturb.timeZoneId,
      startMeridiem: nodisturb.startMeridiem,
      endMeridiem: nodisturb.endMeridiem,
      wheatherChecked: nodisturb.checked
    });
  }, [nodisturb]);

  return (
    <div className="sign-up Subscriptions ssp-well container">
      <I18NConsumer>
        {(i18n) => setPageTitle(`${orgName} - ${i18n.get('ssp.main.title.subscriptions')}`)}
      </I18NConsumer>
      {!isEditMode && <SignUpHeader currentSection={signUpConstants.SIGN_UP_SECTIONS.subscriptions.id} />
      }
      <I18N
        tag={SignUpContent}
        isInLoggedInEditProfileMode={isEditMode}
        i18n-title={isEditMode ? 'ssp.main.mySubscriptions' : 'ssp.main.title.subscriptions'}
        hasRightCard={false}
        >
        <div className="form-group row pt-4 p-2">
          <div className="col-md-12">
            <p><I18N>subscription.checkbox.instruction</I18N></p>
            <AlertBox message='home.alert.box.message.mySubscriptions' isSavedSucceed={isSavedSucceed} />
            {
              showGroupSubscription && optInGroups.groups &&
                <GroupSubscriptionContent
                  isInLoggedInEditProfileMode={isEditMode}
                  setGroupData={(groupObj) => setGroupData(_.assignIn(groupData, groupObj))}
                />
            }
            {
              showAlertSubscription &&
                <SubscriptionContent
                  setAlertData={(leafObj) => setAlertData(_.assignIn(alertData, leafObj))}
                  nodisturb={nodisturbData}
                  handleConfirmWindowShow={setIsOpenUncheckConfirm}
                  handleWheatherTimeChange={(obj) => setNodisturbData({
                    ...nodisturbData,
                    ...obj
                  })}
                  handleIsShowSkipBtn={setIsShowSkipBtn}
                  showAlertSubscriptionTimeZone={showAlertSubscriptionTimeZone}
                  countRoot={(indexes, checked)=>updateSubHeap(indexes, checked)}
                  isInLoggedInEditProfileMode={isEditMode}
                />
            }
            {
              shouldIncidentSubShow &&
                <IncidentSubscriptions
                  contactId={contactId}
                  csrfToken={csrfToken}
                  accountName={accountName}
                  viewName="edit"
                  setLoadingIncSubs={setLoadingIncSubs}
                  lang={lang}
                  setSaveIncSubAssignments={(saveAssignments) => {
                    setSaveIncSubAssignments(() => saveAssignments);
                  }}
                />
            }
            {
              isShowAlertInfo &&
              <EBModal
                type="warn"
                isOpen={isShowAlertInfo}
                toggleModal={() => setIsShowAlertInfo(false)}
                ebTestOkValue="wheather-alert-ok"
              >
                <div tabIndex="0"><I18N>{alertContent}</I18N></div>
              </EBModal>
            }
            {isOpenUncheckConfirm &&
              <EBModal
                isOpen={isOpenUncheckConfirm}
                toggleModal={() => setIsOpenUncheckConfirm(false)}
                onConfirm={() => {
                  setNodisturbData({
                    ...nodisturbData,
                    wheatherChecked: false
                  });
                }}
                ebTestCancelValue="time-uncheck-cancel"
                ebTestConfirmValue="time-uncheck-confirm"
              >
                <div tabIndex="0"><I18N>ssp.location.remove.confirm</I18N></div>
              </EBModal>
            }
            <div className="offset-md-3 col-md-9 pr-0 mt-2">
              <div className="row">
                {isEditMode &&
                  <CancelButton
                    isShow
                    onClick={() => {
                      navigate('home');
                    }}
                    ebTestValue="ssp_subscription_button_cancel"
                  />
                }
                {!isEditMode && (isNewEditPage ?
                  <CancelButton
                    isShow
                    onClick={() => {
                      goNextPage({ pageUri: 'edit-subscriptions', contactId });
                    }}
                    ebTestValue="ssp_subscription_button_cancel"
                  /> : <SkipButton
                    isShow={isShowSkipBtn}
                    onClick={() => {
                      goNextPage({ pageUri: 'edit-subscriptions', showCustomfield, contactId });
                    }}
                    ebTestValue="ssp_subscription_button_skip"
                  />)
                }
                {displaySaveButton && <SaveButton
                  onClick={() => {setSavedSucceed(false); handleSave()}}
                  ebTestValue="ssp_subscription_button_save"
                  type="button"
                  hasContinue={!isNewEditPage && !isEditMode}
                />}
              </div>
            </div>
          </div>
        </div>
      </I18N>
    </div>
  );
};

Subscriptions.propTypes = {
  getSubscriptions: PropTypes.func.isRequired,
  getGroupSubscriptionData: PropTypes.func.isRequired,
  nodisturb: PropTypes.shape(),
  subscriptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  updateAlertSubscriptionList: PropTypes.func.isRequired,
  selectedGroupIds: PropTypes.arrayOf(PropTypes.number),
  optInGroups: PropTypes.shape(),
  updateGroupSubscriptionData: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  shouldIncidentSubShow: PropTypes.bool.isRequired,
  checkShowIncidentSub: PropTypes.func.isRequired,
};
Subscriptions.defaultProps = {
  nodisturb: {
    startTime: '',
    endTime: '',
    timeZoneId: '',
    startMeridiem: '',
    endMeridiem: '',
    checked: false,
  },
  selectedGroupIds: [],
  optInGroups: {
    groups: []
  },
  isEditMode: false
};
const mapStateToProps = state => ({
  nodisturb: selectSignUpNodisturb(state),
  subscriptions: selectSignUpSubscriptions(state),
  selectedGroupIds: selectSelectedGroupIds(state),
  optInGroups: selectOptInGroups(state),
  shouldIncidentSubShow: selectShouldShowIncidentSub(state),
});

const mapDispatchToProps = dispatch => ({
  checkShowIncidentSub: data => dispatch(subscriptionActions.checkShowIncidentSub.action(data)),
  getSubscriptions: (accountId) => dispatch(signUpActions.getSubscriptions.action({ accountId })),
  getGroupSubscriptionData: (contactId) =>
    dispatch(subscriptionActions.getGroupSubscriptionList.action({ contactId })),
  updateGroupSubscriptionData: (contactId, data) =>
    dispatch(subscriptionActions.updateGroupSubscriptionList.action({ contactId, ...data })),
  updateAlertSubscriptionList: (contactId, data) =>
    dispatch(subscriptionActions.updateAlertSubscriptionList.action({ contactId, ...data })),
  clearData: () => dispatch(subscriptionActions.clearSubscriptionsData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);
